import { SDK_SEASON } from '@pff-consumer/schema'

export const getSeasonForGrades = (season: number | undefined, isNewSeasonUpcoming: boolean) => {
  if (!season) {
    return SDK_SEASON
  }

  // If the next season's week 1 game is about to start, display the last year data, after week 1 is over display the current season's data
  return isNewSeasonUpcoming ? season - 1 : season
}
